import { TypographyLabel } from '../../typography'
import { CalendarIcon, LinkIcon, FullScreenIcon } from '../../icons'
import { formatDateToLongFormat } from '#app/utils/timeUtils'
import Button from '../../buttons/button'
import Image from '#app/components/common/image.tsx'
import { Modal } from '../../modalsAndOverlays'
import { useState } from 'react'

type TweetProps = {
	metadata: {
		properties: {
			url?: string
			ipfsCID?: string
			timestamp?: string
			web2URL?: string
		}
	}
}

export default function Tweet({ metadata }: TweetProps) {
	const { properties } = metadata
	const [isImageModalOpen, setIsImageModalOpen] = useState(false)

	return (
		<div className="flex flex-col space-y-2">
			{/* Date with Icon */}
			{properties.timestamp && (
				<div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
					<CalendarIcon size="small" />
					<TypographyLabel size="small">
						{formatDateToLongFormat(properties.timestamp || '')}
					</TypographyLabel>
				</div>
			)}

			{/* Web2 URL Image */}
			{(properties.web2URL || properties.ipfsCID) && (
				<div
					className="group relative cursor-pointer overflow-hidden rounded-lg transition-all duration-200"
					onClick={() => setIsImageModalOpen(true)}
				>
					<Image
						imageUrl={
							properties.web2URL ? properties.web2URL : properties.ipfsCID
						}
						imageAlt="Tweet preview"
						containerClassName="rounded-lg overflow-hidden bg-uiPrimaryLight dark:bg-uiTertiaryDark hover:brightness-50 "
						className="h-[180px] w-full object-contain"
					/>
					<div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-200 group-hover:opacity-100">
						<div className="absolute inset-0 bg-black/30"></div>
						<FullScreenIcon size="large" className="relative z-10 text-white" />
					</div>
				</div>
			)}

			{/* View Original Tweet Link */}
			{properties.url && (
				<a
					target="_blank"
					rel="noreferrer"
					href={properties.url}
					className="flex flex-row space-x-1"
				>
					<Button
						variant="tertiary"
						size="xSmall"
						additionalClasses="flex flex-row space-x-0"
						leftIcon={<LinkIcon size="small" />}
					>
						View Original Tweet
					</Button>
				</a>
			)}

			{/* Image Modal */}
			<Modal
				size="xLarge"
				isOpen={isImageModalOpen}
				onClose={() => setIsImageModalOpen(false)}
				body={
					<div className="flex items-center justify-center">
						<Image
							imageUrl={
								properties.web2URL ? properties.web2URL : properties.ipfsCID
							}
							imageAlt="Tweet preview"
							containerClassName="rounded-lg overflow-hidden bg-uiPrimaryLight dark:bg-uiTertiaryDark"
							className="h-auto w-full object-contain"
						/>
					</div>
				}
			/>
		</div>
	)
}
